document.addEventListener('DOMContentLoaded', () => {
  const table = document.querySelector('.variant-table');
  if (!table) return;

  /* ------------------------
      GLOBAL HELPERS
  ------------------------- */

  // Central max quantity handler
  function getMaxQty(row) {
    if (row.dataset.variantQty === undefined) return null; // unlimited qty
    const qty = parseInt(row.dataset.variantQty, 10);
    return isNaN(qty) ? null : qty;
  }

  async function fetchCart() {
    try {
      const res = await fetch('/cart.js', { cache: 'no-store' });
      return await res.json();
    } catch (err) {
      console.error('Failed to fetch cart:', err);
      return { items: [] };
    }
  }

  async function updateCartItem(variantId, quantity) {
    const row = table.querySelector(`.variant-row[data-variant-id="${variantId}"]`);
    if (!row) return;
    row.classList.add('loading');

    try {
      const cart = await fetchCart();
      const existingItem = cart.items.find(i => i.variant_id == variantId);

      let endpoint = '';
      let body = {};

      if (quantity > 0) {
        endpoint = existingItem ? '/cart/change.js' : '/cart/add.js';
        body = existingItem ? { id: existingItem.key, quantity } : { id: variantId, quantity };
      } else if (existingItem) {
        endpoint = '/cart/change.js';
        body = { id: existingItem.key, quantity: 0 };
      } else {
        row.classList.remove('loading');
        return;
      }

      const res = await fetch(endpoint, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(body),
      });

      if (!res.ok) {
        const errorData = await res.json();
        console.warn('Shopify cart error:', errorData);

        if (errorData.message) alert(errorData.message);

        const updatedCart = await fetchCart();
        await prefillVariantQuantities();
        updateCartBubble(updatedCart.item_count);
        return;
      }

      const updatedCart = await fetchCart();
      updateCartBubble(updatedCart.item_count);
      updateRowTotal(row, quantity);
      console.log(`🛒 Cart updated for variant ${variantId} → qty ${quantity}`);
      showMessage("Cart updated successfully!", "#008000");
    } catch (err) {
      console.error('Error updating cart:', err);
    } finally {
      row.classList.remove('loading');
    }
  }

  function updateCartBubble(totalQuantity) {
    const cartBubble = document.querySelector('.cart-bubble');
    const bubble = document.querySelector('.cart-bubble__text-count');

    if (bubble) bubble.textContent = totalQuantity;

    if (cartBubble && totalQuantity > 0) {
      cartBubble.classList.remove('visually-hidden');
      bubble.classList.remove('hidden');
    } else if (cartBubble) {
      cartBubble.classList.add('visually-hidden');
      bubble.classList.add('hidden');
    }
  }

  function updateRowTotal(row, quantity) {
    const price = parseFloat(row.dataset.variantPrice) / 100;
    const totalCell = row.querySelector('.variant-cell.total');
    const total = (price * quantity).toFixed(2);
    if (totalCell) totalCell.textContent = quantity > 0 ? `$${total}` : '—';
  }

  async function prefillVariantQuantities() {
    const cart = await fetchCart();
    const cartMap = new Map();

    cart.items.forEach(item => cartMap.set(item.variant_id, item.quantity));

    const rows = table.querySelectorAll('.variant-row');

    rows.forEach(row => {
      const variantId = parseInt(row.dataset.variantId, 10);
      const input = row.querySelector('quantity-selector-component input');
      if (!input) return;

      const quantity = cartMap.get(variantId) || 0;
      input.value = quantity;

      if (quantity > 0) {
        row.classList.add('in-cart');
        updateRowTotal(row, quantity);
      } else {
        row.classList.remove('in-cart');
        updateRowTotal(row, 0);
      }
    });

    updateCartBubble(cart.item_count);
  }

  function bindAddToCartButtons() {
    const buttons = document.querySelectorAll('.add-to-cart-btn');

    buttons.forEach(button => {
      button.addEventListener('click', async e => {
        const row = e.target.closest('.variant-row');
        if (!row) return;

        const variantId = row.dataset.variantId;
        const maxQty = getMaxQty(row);
        const input = row.querySelector('quantity-selector-component input');

        let quantity = parseInt(input?.value || 0, 10);

        if (maxQty !== null && quantity > maxQty) {
          quantity = maxQty;
          input.value = maxQty;
          showMessage(`Only ${maxQty} units available.`, "#f44336");
        }

        await updateCartItem(variantId, quantity);
      });
    });
  }

  function showMessage(message, bgcolor) {
    let msgBox = document.querySelector('.cart-msg');
    if (!msgBox) {
      msgBox = document.createElement('div');
      msgBox.className = 'cart-msg';
      msgBox.style.cssText = `
        position: fixed;
        bottom: 50px;
        left: 50%;
        transform: translateX(-50%);
        background:#000000;
        color: #fff;
        padding: 10px 20px;
        border-radius: 8px;
        font-size: 14px;
        z-index: 9999;
        opacity: 0;
        transition: opacity 0.3s ease;
      `;
      document.body.appendChild(msgBox);
    }

    msgBox.textContent = message;
    msgBox.style.opacity = 1;
    setTimeout(() => (msgBox.style.opacity = 0), 5000);
  }

  function bindBulkCartButton() {
    const bulkBtn = document.querySelector('.btn-add-update-cart');
    if (!bulkBtn) return;

    bulkBtn.addEventListener('click', async () => {
      bulkBtn.disabled = true;
      bulkBtn.textContent = "Updating...";

      const rows = document.querySelectorAll('.variant-row');
      let updates = {};

      rows.forEach(row => {
        const variantId = row.dataset.variantId;
        const maxQty = getMaxQty(row);
        const input = row.querySelector('quantity-selector-component input');
        if (!variantId || !input) return;

        let quantity = parseInt(input.value || 0, 10);

        if (maxQty !== null && quantity > maxQty) {
          quantity = maxQty;
          input.value = maxQty;
          showMessage(`Only ${maxQty} units available.`, "#f44336");
        }

        updates[variantId] = quantity;
      });

      try {
        const res = await fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ updates })
        });

        const cart = await res.json();
        await prefillVariantQuantities();
        updateCartBubble(cart.item_count);

        showMessage("Cart updated successfully!", "#008000");

      } catch (err) {
        console.error("Bulk update failed:", err);
        showMessage("Something went wrong. Try again.", "#f44336");
      }

      bulkBtn.disabled = false;
      bulkBtn.textContent = "Add to cart";
    });
  }

  function bindQuantityLiveUpdate() {
    const rows = document.querySelectorAll('.variant-row');

    rows.forEach(row => {
      const input = row.querySelector('quantity-selector-component input');
      if (!input) return;

      input.addEventListener('input', () => {
        let qty = parseInt(input.value || 0, 10);
        console.log('check qty-',qty);
       // updateRowTotal(row, isNaN(qty) ? 0 : qty);
          if (isNaN(qty) || qty < 0) {
            qty = 0;
            input.value = 0;
          }
           updateRowTotal(row, qty);
      });

      const minusBtn = row.querySelector('.quantity-minus');
      const plusBtn = row.querySelector('.quantity-plus');

      if (minusBtn) {
        minusBtn.addEventListener('click', () => {
          setTimeout(() => {
            const qty = parseInt(input.value || 0, 10);
            updateRowTotal(row, isNaN(qty) ? 0 : qty);
          }, 50);
        });
      }

      if (plusBtn) {
        plusBtn.addEventListener('click', () => {
          setTimeout(() => {
            const qty = parseInt(input.value || 0, 10);
            updateRowTotal(row, isNaN(qty) ? 0 : qty);
          }, 50);
        });
      }
    });
  }
 
  /* start PDP table sorting */
const rowsContainer = document.querySelector(".variant-table");

function getRows() {
  return [...document.querySelectorAll(".variant-row:not(.variant-header)")];
}

const sortState = {
  item: "none",
  price: "none",
  Texture: "none",
  Roll_Size: "none",
  price_per_sqft: "none"
};

function parsePricePerSqft(row) {
  const el = row.querySelector(".price_per_sqft");
  if (!el) return NaN;
  const txt = el.textContent || "";
  const num = parseFloat(txt.replace(/[^0-9.\-]/g, ""));
  return isNaN(num) ? NaN : num;
}

function getValue(row, type) {
  if (type === "item") {
    const el = row.querySelector(".sku");
    return el ? el.textContent.trim() : "";
  }
  if (type === "price") {
    const v = row.dataset.variantPrice;
    return v ? parseFloat(v) : NaN;
  }
  if (type === "Texture") {
    const el = row.querySelector(".left-col .variant-cell:nth-child(2), .variant-cell"); 
    const left = row.querySelector(".left-col");
    if (left) {
      const cells = left.querySelectorAll(".variant-cell");
      if (cells.length >= 2) return (cells[1].textContent || "").trim();
    }
    const t = row.querySelector(".variant-cell:nth-child(2)");
    return t ? t.textContent.trim() : "";
  }
  if (type === "Roll_Size") {
    const left = row.querySelector(".left-col");
    if (left) {
      const cells = left.querySelectorAll(".variant-cell");
      if (cells.length >= 3) return (cells[2].textContent || "").trim();
    }
    return "";
  }
  if (type === "price_per_sqft") {
    return parsePricePerSqft(row);
  }
  return "";
}

document.querySelectorAll(".sort-btn").forEach(button => {
  button.addEventListener("click", () => {
    const type = button.dataset.sort;
    const rows = getRows();

    let direction = sortState[type] === "asc" ? "desc" : "asc";
    if (sortState[type] === "none" && type === "item") {
      const curr = rows.map(r => getValue(r, type));
      const isAsc = curr.every((v, i, arr) => i === 0 || (String(arr[i - 1]).localeCompare(String(v)) <= 0));
      if (isAsc) direction = "desc";
    }

    const sorted = [...rows].sort((a, b) => {
      let A = getValue(a, type);
      let B = getValue(b, type);

      const aIsNum = typeof A === "number" && !isNaN(A);
      const bIsNum = typeof B === "number" && !isNaN(B);

      if (aIsNum && bIsNum) {
        return direction === "asc" ? A - B : B - A;
      }

      A = (A === null || A === undefined) ? "" : String(A).trim().toLowerCase();
      B = (B === null || B === undefined) ? "" : String(B).trim().toLowerCase();
      return direction === "asc" ? A.localeCompare(B) : B.localeCompare(A);
    });

    sortState[type] = direction;
    sorted.forEach(r => rowsContainer.appendChild(r));

    document.querySelectorAll(".sort-btn").forEach(btn => {
      btn.classList.remove("active", "desc");
    });
    button.classList.add("active");
    if (direction === "desc") button.classList.add("desc");
  });
});
/* END PDP table sorting */

  window.addEventListener('pageshow', async (e) => {
    console.log('page show -', e.persisted);
    if (e.persisted) {
      await prefillVariantQuantities();
    }
  });
  bindAddToCartButtons();
  prefillVariantQuantities();
  bindBulkCartButton();
  bindQuantityLiveUpdate();

});
